import React from 'react';
import { RichText, Image, Link } from '@sitecore-jss/sitecore-jss-react';
import DictionaryText from './DictionaryText';
import FormatedDate from '../../utils/FormatedDate';
import pin from '../../assets/icons/pin.svg';
import whiteExternalLink from '../../assets/icons/white-external-link.svg';
import { getAbsoluteUrl } from '../../utils/urlHelper';

const ImageCard = (props) => {
  const { image, date, title, theme = 'light', description, readmore, link, sitecoreContext } = props;
  const absoluteLink = getAbsoluteUrl(link, sitecoreContext);

  return (
    <a href={absoluteLink} target="_blank" rel="noreferrer noopener" className="w-full block h-fit group">
      <div className="mxl:h-[230px] h-[194px] overflow-clip flex bg-[#F2F2F1]">
        <Image field={image} className="md:px-4 lg:px-0 max-w-8/12 max-h-full m-auto group-hover:scale-105 transition-all duration-500 object-cover object-center" />
      </div>
      <div>
        <div className="flex mt-6 gap-2 items-center">
          {/* <img src={pin} className="bg-sans-100 rounded-full w-10" /> */}
          <div className="text-base text-black-300 font-semibold" dir="ltr">
            {date && <FormatedDate date={date} />}
          </div>
        </div>
        <RichText field={title} className={`mt-2 font-bold text-xl ${theme === 'light' ? 'text-dark-300' : 'text-white'}`} />
        {/* <RichText field={description} className={`mt-2 leading-7 font-medium text-base ${theme === 'light' ? 'text-dark-500' : 'text-white'}`} /> */}
        <div className="w-fit">
          {readmore && link && <div className="mt-[16px] mb-[24px] duration-300 text-sm text-white">
            {/* <DictionaryText dictionaryKey="read-more" />
            <img src={externalLink} className="inline mx-[10px] h-[13px]" /> */}
            <div className="w-full h-fit main-button clip-button">
              <button className="px-[21px] py-[11px] rounded-l rounded-r-md leading-none bg-red-500 hover:bg-red-600 duration-300 font-bold active:bg-gray-400 active:text-red-500 text-white">
                <img src={whiteExternalLink} className="inline h-[20px]" />
              </button>
            </div>
          </div>
          }
        </div>
      </div>
    </a>
  );
};

export default ImageCard;
